import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import _ from 'lodash';

import TripCard from '../TripCard/TripCard';

import { getResponseConfig } from '../../utilities/slider/responsiveConfig'
import '../../styles/scss/components/slick.scss';
import '../../styles/scss/components/slick-theme.scss';
import '../../styles/scss/components/card-carousel.scss';

/* eslint-disable-next-line react/prop-types */
const PrevArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props} aria-label="Previous" type="button">
    <div className="image-carousel-arrow arrow-left"/>
    <div className="image-carousel-arrow-background" />
  </button>
);
/* eslint-disable-next-line react/prop-types */
const NextArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props} aria-label="Next" type="button">
    <div className="image-carousel-arrow arrow-right"/>
    <div className="image-carousel-arrow-background" />
  </button>
);

const CardCarousel = ({ tours }) => {
  return (
    <Slider
      className="image-carousel-container"
      dots
      infinite={false}
      responsive={_.size(tours) > 1 && getResponseConfig(_.size(tours))}
      prevArrow={<PrevArrow />}
      nextArrow={<NextArrow />}
    >
      {_.map(tours, tour => (
        <TripCard
          key={tour.id}
          trip={tour}
        />
      ))}
    </Slider>
  );
};

CardCarousel.propTypes = {
  tours: PropTypes.arrayOf(
    PropTypes.shape()
  ).isRequired,
};

export default CardCarousel;
